<template>
    <div class="container">
        <h1>Aanmelden Werkzaamheden</h1>
        <p>
            U heeft nog <strong>{{$store.getters.credits}}</strong> credits.
            <br/><small><strong>1 aanmelding = 8 credits + 4 credits per pas.</strong></small>
            <br /><small class="red" v-if="$store.getters.credits < 12">U heeft onvoldoende tegoed. <router-link tag="a" :to="{ name: 'ClientProfileCredits' }">Opwaarderen!</router-link></small>
        </p>

        <div class="alert alert-info shadow"><strong>Belangrijk!</strong> Middels de onderstaande aanmelding, wordt de politie geinformeerd over de werkzaamheden en mag het ingeleende personeel op een ander legitimatiebewijs te werk gesteld worden.</div>
        <p>Conform de BPBR, artikel 19, dienen de beveiligingswerkzaamheden aangemeld te worden bij de Korpschef. Tevens moet het duidelijk zijn welke beveiligingsorganisatie verantwoordelijk is voor de werkzaamheden en de bekwaamheid gecontroleerd kunnen worden middels een legitimatiebewijs, zoals gesteld in artikel 9 lid 8. Het ingeleende personeel moet bekend zijn in de <a href="https://id.azurity.nl" target="_blank">Azurity Identity App</a>.</p>
        <p>Het ingeleende personeel mag dus op een legitimatiebewijs van een andere beveiligingsorganisatie werken, mits, middels de onderstaande aanmelding, de werkzaamheden in de <a href="https://id.azurity.nl" target="_blank">Azurity Identity App</a> bekend zijn. De politie wordt automatisch geinformeerd over de werkzaamheden conform Bijlage 4, BPBR.</p>
        <div class="alert alert-warning shadow"><strong>Let op!</strong> Indien de werkzaamheden niet hier aangemeld zijn, mag het ingeleende personeel niet te werk gesteld worden op een ander legitimatiebewijs. U bent verantwoordelijk voor het invoeren van de juiste pasnummers. Eventuele boetes door de handhavende instanties komen voor rekening van de inlenende organisatie.</div>


        <div class="text-right mt-5">
            <button class="btn btn-outline-azure-dark" @click="add">
                <font-awesome-icon icon="plus" class="mr-1"></font-awesome-icon>
                Activiteit Toevoegen
            </button>
        </div>
        <div class="table-responsive">
        <table class="table table-sm mt-3">
                <thead>
                    <tr>
                        <th>Datum</th>
                        <th colspan="1">Omschrijving</th>
                        <th>Politie Eenheid</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody v-if="isLoading || activities.length == 0">
                    <tr>
                        <td colspan="4" class="text-center pt-5">
                            <loader width="3rem" v-if="isLoading"></loader>
                            <h4 class="text-muted" v-else>Geen recente activiteiten gevonden...</h4>
                        </td>
                    </tr>
                </tbody>
                <tbody v-for="(l, index) in activities" :key="l.id" v-else>
                    <tr @click="toggle($event, l.id)" :class="{ 'bg-warning': l.id <= 0}">
                        <td>
                            <input type="date" 
                            :class="['form-control', ($v.activities.$each[index.toString()].date.$dirty) ? ($v.activities.$each[index.toString()].date.$error) ? 'is-invalid' : 'is-valid' : '']"
                            v-model="l.date" 
                            v-if="l.id <= 0"  />
                            <input class="form-control-plaintext ellipsis" :value="new Date(l.date).toLocaleString()" disabled v-else />
                        </td>
                        <td colspan="1">
                            <input type="text" class="form-control-plaintext ellipsis" :value="l.activityPasses.length + 'x ' + l.description" disabled />
                        </td>
                        <td colspan="1">
                            <select v-if="l.id <= 0" 
                            :class="[l.id > 0 ? 'form-control-plaintext' : 'form-control']" 
                            v-model="l.policeUnitId" name="police-unit" id="police-unit" 
                            :disabled="l.id > 0 || l.loading" > 
                                <option :value="u.id" v-for="u in $store.getters.policeUnits" :key="u.id" >{{u.name}}</option>
                            </select>
                            <input class="form-control-plaintext ellipsis" :value="$store.getters.policeUnits.find((c) => { return c.id == l.policeUnitId}).name" disabled v-else />
                        </td>
                        <td class="text-right pt-2">
                            <loader v-if="l.loading"></loader>
                            <div v-else>
                                <button class="btn btn-sm btn-success" v-if="l.id <= 0" @click="request(l)" :disabled="$store.getters.credits < (8 + (l.activityPasses.length * 4))">Aanmelden</button>
                                <strong v-else >Aangemeld!</strong>
                                <button class="btn btn-sm btn-danger ml-3" v-if="l.id <= 0" @click="remove(l)">
                                    <font-awesome-icon icon="trash-alt"></font-awesome-icon>
                                </button>
                            </div>
                        </td>
                    </tr>
                    <transition name="slide">
                        <tr :class="['details', { 'table-warning': l.id <= 0}]">
                            <td colspan="2">
                                <label class="col-form-label">Werkzaamheden</label>
                                <textarea rows="5" type="text" 
                                :class="[l.id > 0 ? 'form-control-plaintext' : 'form-control', ($v.activities.$each[index.toString()].description.$dirty) ? ($v.activities.$each[index.toString()].description.$error) ? 'is-invalid' : 'is-valid' : '']"
                                :disabled="l.id > 0 || l.loading" 
                                v-model="l.description" placeholder="Type hier een omschrijving van de werkzaamheden..." />
                            </td>
                            <td colspan="1">
                                <label class="col-form-label">Objectgegevens</label>
                                <textarea rows="5" type="text"                                 
                                :class="[l.id > 0 ? 'form-control-plaintext' : 'form-control', ($v.activities.$each[index.toString()].object.$dirty) ? ($v.activities.$each[index.toString()].object.$error) ? 'is-invalid' : 'is-valid' : '']"
                                :disabled="l.id > 0 || l.loading" 
                                v-model="l.object" placeholder="Type hier de adresgegevens van het object..." />
                            </td>
                            <td>
                                <label class="col-form-label d-flex justify-content-between">
                                    <div class="">
                                        Pasnummers
                                    </div>
                                    <div class="text-right" v-if="l.id <= 0">
                                        <button class="btn btn-outline-success btn-sm" 
                                        :disabled="l.loading"
                                        @click="addPass(l)">
                                            <font-awesome-icon icon="plus"></font-awesome-icon>
                                        </button>
                                    </div>
                                </label>
                                <div class="input-group mb-2"
                                    v-for="(pass, pIndex) in l.activityPasses" :key="pass.id">
                                    <input type="number" 
                                        :class="['form-control input-sm', ($v.activities.$each[index.toString()].activityPasses.$each[pIndex.toString()].$dirty) ? ($v.activities.$each[index.toString()].activityPasses.$each[pIndex.toString()].$error) ? 'is-invalid' : 'is-valid' : '']"
                                        v-model="pass.passNumber" 
                                        :disabled="l.loading"
                                        placeholder="Pas-nummer..." />
                                    <div class="input-group-append"  v-if="l.id <= 0">
                                        <button class="btn btn-sm btn-outline-danger" 
                                        :disabled="l.loading || l.activityPasses.length === 1"
                                        @click="l.activityPasses.splice(l.activityPasses.indexOf(pass), 1)">
                                            <font-awesome-icon icon="trash-alt"></font-awesome-icon>
                                        </button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </transition>
                </tbody>
            </table>
        </div>
        <vue-toastr ref="toastr"></vue-toastr>
    </div>
</template>

<script>
import Loader from '@/components/Loader';
import VueToastr from "vue-toastr";
import { validationMixin } from 'vuelidate'
import { required, minLength, maxLength, helpers } from 'vuelidate/lib/validators'
import { passNumber, isDateGreaterThanToday, arrayIsNotNull } from '@/mixins/validations'
export default {
    mixins: [validationMixin],
    components: {
        Loader,
        VueToastr
    },
    data() {
        return {
            isLoading: true,
            policeUnits: [],
            activities: []
        }
    },
    validations: {
        activities: {
            $each: {
                date: {
                    required,
                    isDateGreaterThanToday
                },
                object: {
                    required
                },
                description: {
                    required
                },
                policeUnitId: {
                    required
                },
                activityPasses: {
                    arrayIsNotNull,
                    $each: {
                        passNumber: {
                            required,
                            passNumber
                        }
                    }
                }
            }
        }
    },
    mounted() {
        this.$refs.toastr.defaultPosition = "toast-bottom-right";
        this.$store.dispatch("GET_CREDITS");
        this.$store.dispatch('GET_POLICEUNITS');
        this.get();
    },
    methods: {
        get() {
            this.isLoading = true;
            this.$http.get('api/Activities').then((res) => {
                this.activities = res.data.map((a) => {
                    a.loading = false;
                    if(a.activityPasses == null)
                        a.activityPasses = [];
                    return a;
                });
            }).finally(() => {
                this.isLoading = false;
            })
        },
        add() {    
            let min = (this.activities.length > 0) ? Math.min.apply(Math, this.activities.map(function(o) { return o.id; })) : 0;
            this.activities.unshift({
                id: (min < 0) ? min - 1 : -1,
                description: '',
                policeUnitId: this.$store.getters.user.policeUnitId,
                object: null,
                date: null,
                credits: 4,
                show: true,
                loading: false,
                activityPasses: [{ id: -1, passNumber: null }]
            });
        },
        addPass(activity) {
            let min = Math.min.apply(Math, activity.activityPasses.map(function(o) { return o.id; }));
            activity.activityPasses.push({
                id: (min < 0) ? min - 1 : -1,
                passNumber: null
            })
        },
        request(activity) {
            this.$v.$touch();
            if(!this.$v.activities.$each[this.activities.indexOf(activity)].$invalid)
            {
                activity.loading = true;
                this.$http.post('api/Activities/Add', activity).then((res) => {
                    activity.id = res.data;
                    this.$refs.toastr.s("Activiteit aangemeld!");
                    this.$store.dispatch("GET_CREDITS");
                }).catch((res) => {
                    this.$refs.toastr.e(res.data);
                }).finally(() => {
                    activity.loading = false;
                })
            };
        },
        remove(activity) {
            this.activities.splice(this.activities.indexOf(activity), 1);
        },
        toggle(ev, id)
        {
            if(id > 0)
            {
                if(!ev.currentTarget.classList.contains("bg-primary"))
                {
                    ev.currentTarget.closest('table').querySelectorAll('.bg-primary').forEach((i) => {
                        i.classList.toggle('bg-primary');
                        i.nextSibling.classList.toggle('table-primary');
                    });
                }
                ev.currentTarget.classList.toggle('bg-primary');
                ev.currentTarget.nextSibling.classList.toggle('table-primary');
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/transitions.scss";

.details {
    display: none;
    &.table-primary,
    &.table-warning {
        display: table-row;
    }
}
</style>